import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import store from "@/store";
import whitePages from "./whitePages";
import { ElMessage } from "element-plus";
export const constantRoutes = routes;
const router = createRouter({
    routes: constantRoutes,
    history: createWebHistory(),
});
// 路由前置守卫，跳转前的一些处理
router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        next();
    }
    else {
        if (!store.getGlobalState('token')) {
            next('/login' + window.location.search);
        }
        else {
            if (!checkRoute(to.path)) {
                ElMessage.error('没有权限');
                console.log('没有权限');
                return;
            }
            next();
        }
    }
});
// 每次跳转前，检查要跳转的路由是否存在，不存在给出提示，存在next()
function checkRoute(path) {
    const userAllRoute = store.getGlobalState('userAllRoute');
    // 判断
    const res = userAllRoute.some(({ route }) => (route == path || route == path + '/'));
    // 判断白名单
    const isInWhiteList = whitePages.some(({ path: whiteRoute }) => whiteRoute === path);
    return res || isInWhiteList;
}
export default router;
